/**
 * v-ripple directive — adds a Material-style ripple effect on touch/click.
 * Only active on touch devices (@media (pointer: coarse)).
 */
export const ripple = {
  mounted(el) {
    el.style.position = el.style.position || "relative";
    el.style.overflow = "hidden";
    el.style.webkitTapHighlightColor = "transparent";

    const handler = (e) => {
      // Only run on touch devices
      if (!window.matchMedia("(pointer: coarse)").matches) return;

      const rect = el.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
      const size = Math.max(rect.width, rect.height) * 2;

      const rippleEl = document.createElement("span");
      rippleEl.style.cssText = `
        position: absolute;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.12);
        width: ${size}px;
        height: ${size}px;
        left: ${x - size / 2}px;
        top: ${y - size / 2}px;
        transform: scale(0);
        opacity: 1;
        pointer-events: none;
        animation: v-ripple-anim 500ms ease-out forwards;
      `;

      el.appendChild(rippleEl);
      setTimeout(() => rippleEl.remove(), 500);
    };

    el.addEventListener("pointerdown", handler);
    el._rippleCleanup = () => el.removeEventListener("pointerdown", handler);
  },
  unmounted(el) {
    if (el._rippleCleanup) el._rippleCleanup();
  },
};

// Inject the keyframe once into document head
if (typeof document !== "undefined" && !document.getElementById("v-ripple-style")) {
  const style = document.createElement("style");
  style.id = "v-ripple-style";
  style.textContent = `
    @keyframes v-ripple-anim {
      to { transform: scale(1); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}
